import { Dayjs } from "dayjs"
import { ServerDate } from "helpers/server-date.class"
import { dayjs } from "./dayjs"

export function dayjsServer(input?: string | number | Date | Dayjs) {
  const serverNow = dayjs(new ServerDate().toISOString())
  const localNow = dayjs()
  const skewMs = serverNow.diff(localNow)

  if (!input) {
    return dayjs().add(skewMs, "millisecond")
  }

  return dayjs(input)
}
